<template lang="pug">
.input-radio
    label.input-label-radio {{ label }}

    .radio-options(:style="[{ display : 'flex' }, { flexDirection: radioDirection }]")
        .radio-option(
            v-for='item in list',
            :id='id',
            :value='value',
            @input='$emit("input", $event.target.value)'
        )
            input.radio-option-value(
                type='radio',
                :id='item.label + id',
                :name='id',
                :value='item.id',
                :checked="item.checked"
                :disabled="disabled"
            )
            label(:for="item.label + id").radio-option-label {{ item.label }}
</template>

<script>
export default {
    name: 'RadioButtonComponent',

    props: {
        value: {},
        id: {
            type: String,
            default: () => `radio-button-${Math.ceil(Math.random() * 10000)}`,
        },

        label: {
            type: String,
            default: '',
        },

        list: {
            type: Array,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        radioDirection: {
            type: String,
            default: 'row'
        }
    },
};
</script>

<style>
#input-radio {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    flex-wrap: wrap;
}

.radio-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}

.radio-option-value {
    width: 25px;
    height: 25px;
}

.radio-option-label {
    padding-top: 5px;
    padding-left: 10px;
    height: 33px;
    width: 100%;

    display: flex;
    align-items: center;
}
</style>
